  const FooterList = ({ textVariable }) => {
  

  return (
    <div className="flex top-0 right-0 py-4">
      <div className='w-full'>
        <div className='flex flex-row justify-center border-t border-slate-100 py-4'>
          <img src="/images/logo/mv_app_logo_mini.png" alt="mv-logo-app-mini"/>
        </div>
        <div className='flex flex-col justify-center items-center'>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>{textVariable}</p></div>
            <div className='w-4/4 text-m text-slate-50 justify-center'><p>App PCh v.1.8</p></div>
          </div>
      </div>
    </div>
  );
};

export default FooterList;